import {
  Box,
  Chip,
  Grid,
  CardContent,
  CardActions,
  Typography,
  CardHeader,
  Stack,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import LanguageListSnippet from "./sharedLandingpageSections/LanguageListSnippet";
import KeywordListSnippet from "./sharedLandingpageSections/KeywordListSnippet";
import {getLangDcatVersion} from "../config/commonFunctions";
import validatedImg from "../assets/icons/EU_controlled_icon.svg";
import registeredImg from "../assets/icons/EU-emblem_RGB.svg";
import {ReactComponent as LocalOfferIcon} from "../assets/icons/Hand-Arrow-Up-Light--Streamline-Phosphor.svg";
import {ReactComponent as OpenLockIcon} from "../assets/icons/Lock-Open--Streamline-Sharp-Material-Symbols.svg";
import { useTranslator } from "../context/TranslatorContext";
import {navigate2MyOffer} from "../config/paths";

export default function ConnectorAssetElastic(props) {
  const { data } = props;
  const { language, messages } = useTranslator();
  const defaultLanguage = props.defaultLanguage || language || "en";
  const lrType = data?._source.lrType;
  const publicItem = data?._source.public;
  const externalItem = data._source.external;
  const createdAt = data?._source.createdAt;
  const id = data?._source.id;
  const langDcatVersion = getLangDcatVersion(data?._source?.conformsTo);
  const offerUrl = navigate2MyOffer(id, langDcatVersion);
  const nameArray = data?._source.name;
  const nameObject = nameArray.find(
    (item) => item.language === defaultLanguage
  );
  const title = nameObject ? nameObject.value : null;
  //const contractPolicyLegalcode = data._source.contractPolicyLegalcode;
  const descriptionArray = data?._source.description;
  const descriptionObject = descriptionArray.find(
    (item) => item.language === defaultLanguage
  );
  const description = descriptionObject ? descriptionObject.value : null;
  const maxLength = 200;
  const truncatedDescription =
    description && description.length > maxLength
      ? `${description.slice(0, maxLength)}...`
      : description;
  // const accessPolicyId = data._source.accessPolicyId;
  const regex = /(<([^>]+)>)/gi;
  const contractPolicyTitle = data?._source.contractPolicyTitle;
  const accessPolicyTitle = data._source.accessPolicyTitle || "";
  const contractPolicyDescription = data?._source.contractPolicyDescription;
  const contractPolicyLegalcode  = data?._source.contractPolicyLegalcode;
  const payAmount = data?._source.payAmount;
  const languages = data?._source.dctLanguage;
  const keywords = data?._source.keyword;
  const euControlled = data?._source.euControlled;
  const euRegistered = data?._source.euRegistered;
  const formattedDate = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(createdAt);

  return (<>
      <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1, gap: 2, pb: 1 }}>
      <Box>
        <Link to={offerUrl} style={{ textDecoration: "none", color: "inherit" }} >
          <Typography variant="h4" gutterBottom> {title} </Typography>
        </Link>
        <Typography variant="body2" color="text.secondary">
          {messages.all_pages_created_column}: {formattedDate}
        </Typography>
      </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{alignItems: "center"}}>
        <Chip
          label={lrType}
          size="small"
          variant="outlined"
          sx={{
            backgroundColor: "#EEF2F6",
            color: "#334155",
            fontWeight: 500,
          }}
        />
          {(euControlled === true || euControlled === "true") && (
            <Tooltip title={messages?.eu_controlled_tooltip || "EU Controlled"}>
            <Box
              component="img"
              src={validatedImg}
              alt={messages?.eu_controlled_label || "EU Controlled"}
              sx={{ width: 22, height: 22, opacity: 0.82 }}
            />
            </Tooltip>
          )}
          {(euRegistered === true || euRegistered === "true") && (
          <Tooltip title={messages?.eu_registered_tooltip || "EU Registered"}>
            <Box
              component="img"
              src={registeredImg}
              alt={messages?.eu_registered_label || "EU Registered"}
              sx={{ width: 22, height: 22, opacity: 0.82 }}
            />
          </Tooltip>
          )}
          {payAmount > 0 && <Typography variant="body2" color="text.secondary"> {messages.all_pages_price_label}: {payAmount} &#8364;</Typography>}
          {publicItem === true && (
            <Chip
              icon={<OpenLockIcon style={{ width: 16, height: 16 }} />}
              label={messages.public_tag_message || "PUBLIC"}
              color="success"
              variant="outlined"
              size="small"
            />
          )}
          {externalItem === true &&
              <Chip
                icon={<OpenLockIcon style={{width: 16, height: 16}} />}
                label={messages.external_tag_message || "EXTERNAL"}
                color="success"
                variant="outlined"
                size="small"
              />
            }
        </Stack>

        <Grid container spacing={1} justifyContent="flex-start" alignItems="center">
          <Grid item xs={12}>
            <Typography variant="body1">
              {truncatedDescription && truncatedDescription.replace(regex, "")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" gap={1}>
              <LanguageListSnippet languages={languages} />
              <KeywordListSnippet keywords={keywords} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between", mt: "auto" }}>
        <Box sx={{ display: "flex", gap: 4, p: 1 }}>
          <Link to={offerUrl}
            state={{
              contractPolicyTitle,
              contractPolicyLegalcode,
              contractPolicyDescription,
              payAmount,
              accessPolicyTitle,
              isOpen: data._source.open,
            }}
          >
            <Chip size="medium"
              // className="chip-fab-style"
              variant= "outlined"
              color="primary" label={messages.view_offer_button}
              icon={<LocalOfferIcon className="nav-icon" />}
              className="button--style--primary"/>
          </Link>
          {/* props.policyButtonCmp() */}</Box>
      </CardActions>

    </>
  );
}
